import React from 'react';
import './TalkSkeleton.css';

export const ActionButtonsSkeleton = ({ label }) => (
    <div className="talk-action-skeleton" role="status" aria-label={label} aria-busy="true">
        <span className="talk-skeleton-action" aria-hidden="true" />
        <span className="talk-skeleton-action" aria-hidden="true" />
    </div>
);

/**
 * Skeleton loader for the Talk sidebar conversation list.
 * Mirrors the ConversationItem layout with shimmer animation.
 */
export const ConversationListSkeleton = ({ count = 8 }) => {
    return (
        <div className="talk-skeleton-list">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="talk-skeleton-conversation" style={{ animationDelay: `${index * 0.05}s` }}>
                    <div className="talk-skeleton-avatar" />
                    <div className="talk-skeleton-content">
                        <div className="talk-skeleton-row">
                            <div className="talk-skeleton-name" style={{ width: `${55 + (index % 3) * 15}%` }} />
                            <div className="talk-skeleton-time" />
                        </div>
                        <div className="talk-skeleton-preview" style={{ width: `${65 + (index % 4) * 10}%` }} />
                    </div>
                </div>
            ))}
        </div>
    );
};

/**
 * Skeleton loader for the Talk chat messages area.
 * Alternates between sent/received message bubble placeholders.
 */
export const MessageListSkeleton = ({ count = 6 }) => {
    // Pattern: received, received, sent, received, sent, received
    const pattern = [false, false, true, false, true, false];

    return (
        <div className="talk-skeleton-messages">
            {Array.from({ length: count }).map((_, index) => {
                const isSent = pattern[index % pattern.length];
                return (
                    <div
                        key={index}
                        className={`talk-skeleton-message ${isSent ? 'talk-skeleton-message--sent' : 'talk-skeleton-message--received'}`}
                        style={{ animationDelay: `${index * 0.08}s` }}
                    >
                        {!isSent && <div className="talk-skeleton-msg-avatar" />}
                        <div
                            className="talk-skeleton-msg-bubble"
                            style={{ width: `${30 + (index % 4) * 10}%` }}
                        >
                            <div className="talk-skeleton-msg-line" style={{ width: '90%' }} />
                            {index % 2 === 0 && (
                                <div className="talk-skeleton-msg-line talk-skeleton-msg-line--short" style={{ width: '55%' }} />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
